module.exports = __webpack_public_path__ + "img/type-style2.5154a8da.png";